import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full py-24 px-4 bg-brand-bg border-b border-brand-card" data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-113">
          <div className="flex items-center mb-8" data-id="element-114">
            <div className="h-px bg-brand-text-muted/30 w-12 mr-4" data-id="element-115"></div>
            <span className="text-brand-text-muted font-bold tracking-widest text-sm uppercase" data-id="element-116">
              The Problem
            </span>
          </div>

          <div className="mb-10" data-id="element-117">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-118">
              It’s called{' '}
              <span className="text-brand-accent bg-brand-accent/10 px-2 py-1 rounded" data-id="element-119">
                Proximity Friction
              </span>
              .
            </h2>

            <div className="prose prose-invert prose-lg max-w-none text-brand-text/80" data-id="element-120">
              <p data-id="element-121">
                For decades, your marriage worked because of <em data-id="element-122">distance</em>.
                You had your world; she had hers. Now, those worlds have
                collided into a 24/7 loop of "Whatcha doin'?" and "Could you
                just...?"
              </p>
            </div>
          </div>

          <div className="bg-brand-card border-l-4 border-brand-highlight p-8 my-10 rounded-r-lg shadow-lg" data-id="element-123">
            <div className="flex items-start" data-id="element-124">
              <AlertTriangle className="w-8 h-8 text-brand-highlight mr-4 flex-shrink-0 mt-1" data-id="element-125" />
              <div data-id="element-126">
                <p className="text-2xl font-serif font-bold text-white mb-2" data-id="element-127">
                  You feel policed. She feels over-taxed.
                </p>
                <p className="text-brand-text-muted" data-id="element-128">
                  The result? You’re both walking on eggshells in a house you
                  paid for with your own sweat.
                </p>
              </div>
            </div>
          </div>

          <div className="prose prose-invert prose-lg max-w-none text-brand-text/80" data-id="element-129">
            <p data-id="element-130">
              You end up retreating to the garage just to breathe, while the
              person you love most becomes the person who irritates you most.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}